export default function Pagination({ page, totalPages, onChange }) {
  if (!totalPages || totalPages <= 1) return null;
  const pages = [];
  const from = Math.max(0, page - 2);
  const to = Math.min(totalPages - 1, from + 4);
  for (let i = from; i <= to; i++) pages.push(i);

  return (
    <div className="pagination">
      <button disabled={page === 0} onClick={() => onChange(page - 1)}>
        <i className="bi bi-chevron-left" />
      </button>
      {pages.map((p) => (
        <button key={p} className={p === page ? 'active' : ''} onClick={() => onChange(p)}>
          {p + 1}
        </button>
      ))}
      <button disabled={page >= totalPages - 1} onClick={() => onChange(page + 1)}>
        <i className="bi bi-chevron-right" />
      </button>
    </div>
  );
}
